/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare DNS_socket as byte`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim DNS_socket as byte`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'DNS setup
    '================================================================
    DNS_socket=sock_get("DNS")
    dns_start(DNS_socket)
    'Making a DNS query:
    'dns_connect(PL_SOCK_INTERFACE_NET, "8.8.4.4",0)
    'dns_query("google.com")
    'get the response in callback_dns_answer_acquired
    '-----------------------------------------------------------------`,
    });

    blocks.push({
        location: 'on_sock_data_arrival',
        blockType: BlockType.CODE,
        template: '\tdns_proc_data()',
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: '\tdns_proc_timer()',
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_dns_failure',
        template: `
sub callback_dns_failure(status as en_dns_status_codes)
    '****callback_dns_failure****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_dns_answer_acquired',
        template: `
sub callback_dns_answer_acquired(return_type as en_dns_return_type, byref return_string as string)
    '****callback_dns_answer_acquired****'
    'if return_type=EN_DNS_RET_IP then
    '    sys.debugprint("DNS:" + ddstr(return_string) + "\\r\\n")
    'end if
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_dns_ok',
        template: `
sub callback_dns_ok()
    '****callback_dns_ok****'
end sub
        `,
    });
    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_dns_pre_buffrq',
        template: `
sub callback_dns_pre_buffrq(num_of_pages_required as byte)
    '****callback_dns_pre_buffrq****'
end sub
        `,
    });
    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'callback_dns_buff_released',
        template: `
sub callback_dns_buff_released()
    '****callback_dns_buff_released****'
end sub
        `,
    });

    return blocks;
};
